import React, { useEffect, useState } from "react";
import Modal from "react-modal"
import error_img from "../../assets/images/modal_question.svg";
import CallServer from '../../api/api'

import { NotificationManager } from 'react-notifications';


export default function ApproveModal(props) {
    const [textData, setTextData] = useState(null)

    let userPermissions = null
    if(localStorage.getItem("i18n_user_permissions") !== "undefined"){
        userPermissions = JSON.parse(localStorage.getItem("i18n_user_permissions"));
    }

    const onCloseModal = () => {
        props.onRequestClose();
    }

    const handleApprove = async () => {
        const response = await CallServer.approve_text(textData.key)
        if(response.success){
            NotificationManager.success('Text approved correctly', 'Ok')
            onCloseModal()
        } else {
            NotificationManager.error('Error while editing translations', 'Error')
        }
    }

    const loadTextData = async() => {
        if(props.textKey){
            const response = await CallServer.get_text(["it","en","es"], [props.textKey])
            if(response.success){
                setTextData({
                    key: props.textKey,
                    texts: {
                        it: response?.data[props.textKey]?.it,
                        en: response?.data[props.textKey]?.en,
                        es: response?.data[props.textKey]?.es
                    }
                })
            } else {
                NotificationManager.error('Unable to load text data', 'Oops');
            }
        } else {
            setTextData({
                key: "",
                texts: {
                    it: "",
                    en: "",
                    es: ""
                }
            })
        }
        
    }
    const style = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 10010
        },
        content: {
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: "translate(-50%, -50%)",
            width: '100%',
            maxWidth: "700px",
            border: '0',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: "24px",
            outline: 'none',
            padding: '0'
        }
    }

    useEffect(() => {
        loadTextData()
    }, [props])

    return (
        <>
            <Modal
                closeTimeoutMS={300}
                isOpen={props.show}
                contentLabel="modal"
                onRequestClose={onCloseModal}
                className="center_modal"
                overlayClassName="bottom_modal_overlay"
                ariaHideApp={false}
                style={style}
            >
                <div className="modal-content">
                    <div className='d-flex justify-content-start mb-3'>
                        <button onClick={onCloseModal}>
                            Exit
                        </button>
                    </div>
                    <div className="input-group" >
                        <label>Key ID</label>
                        <input 
                            className={`i18n_input`}
                            name='key'
                            value={textData?.key || ''}
                            disabled={true}
                        />
                    </div>
                    <div className='d-flex align-items-center'>
                        <div className="input-group" >
                            <label>IT Text</label>
                            <textarea 
                                className={`i18n_input`}
                                name='it'
                                value={textData?.texts?.it || ''}
                                disabled={true}
                            />
                        </div>
                    </div>
                    
                    <div className="input-group" >
                        <label>EN Text</label>
                        <textarea 
                            className={`i18n_input`}
                            name='en'
                            value={textData?.texts?.en || ''}
                            disabled={true}
                        />
                    </div>

                    <div className="input-group" >
                        <label>ES Text</label>
                        <textarea 
                            className={`i18n_input`}
                            name='es'
                            value={textData?.texts?.es || ''}
                            disabled={true}
                        />
                    </div>
                    {userPermissions?.write &&
                        <div className='d-flex justify-content-end'>
                            <button className="bg-success" onClick={handleApprove}>
                                Approve Translation
                            </button>
                        </div>
                    }
                </div>
            </Modal>
        </>
    );
}